import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileConfig } from './../../profile.config';

@Component({
  selector: 'view-profile-criminal',
  templateUrl: './view-profile-criminal.component.html',
  providers: []
})

export class ViewProfileCriminalComponent {
  @Input() viewProfileData: Object;
  profileKey: string;

  constructor() {
  }

  ngOnInit() {
    this.profileKey = ProfileConfig.getViewProfileCriminalKey();
  }
}